import { useState, useEffect } from "react";
import { withRouter, Redirect } from "react-router";
import { useTranslation } from "react-i18next";
import {
  SERVER_SETUP,
  SWE_LIMIT_DIALOG,
  PENDING_DEPOSIT,
} from "common/src/helpers/constants";
/* import { QUERY_GET_LIMITS } from "common/src/graphql/queries"; */
/* import { useApolloClient } from "@apollo/client"; */
import { getToken } from "common/src/helpers/session";
import Modal from "react-modal";
import { BannedDialogWithMessage } from "common/src/modal/BannedDialogWithMessage";
import Slides from "common/src/component/Slider";
import { GameProvidersList } from "common/src/component/GameProvidersList";
import Categories from "common/src/component/Categories";
import PlayLive from "common/src/component/PlayLive";
import Lobby from "common/src/component/Lobby";
import PaymentMethods from "common/src/component/PaymentMethods";
import PnP from "common/src/component/PnP";
import config from "../config.json";
import {
  LobbyWrapper,
  StyledProviderLogo,
} from "common/src/styledComponents/StyledGame";
import {
  StyledFader,
  StyledFilters,
  StyledFiltersWrapper,
  StyledLoupeDiv,
  StyledPlayLiveWrapper,
} from "common/src/styledComponents/StyledIndex";
import { StyledTextCenter } from "common/src/styledComponents/AccountPage";
import { StyledLink } from "common/src/styledComponents/CommonStyledComponents";
import useGetGameLobby from "common/src/services/useGetGameLobby";
import { checkSWEDepositLimit } from "common/src/helpers/checkSWEDepositLimit";
import MainDescription from "common/src/component/MainDescription";
import { isMobileOnly } from "react-device-detect";
import GamesLoader from "common/src/component/GamesLoader";

Modal.setAppElement("#root");

const Index = ({
  currentTheme,
  server,
  bannedDepositPage,
  hasWithdraw,
  player,
  riskyCountry,
  setSpinner,
  depositList,
  setPxRegisterStart,
  setPxDepositStart,
  setShowWithdrawAlertDialog,
  setSweLimitDialog,
  pages,
  titles,
  onToggleSearchShow,
  width,
  setIsOpen,
}) => {
  const { t } = useTranslation("");
  const [serverSetup] = useState(sessionStorage.getObject(SERVER_SETUP));
  const [session] = useState(getToken());
  /*  const apolloClient = useApolloClient(); */

  const currentTemplate = serverSetup.template;
  const [showBannedDialogWithMessage, setShowBannedDialogWithMessage] =
    useState(false);
  const [supportRedirect, setSupportRedirect] = useState(false);
  const [scrollOnBack, setScrollOnBack] = useState(false);

  let firstCategory =
    serverSetup &&
    serverSetup.gameCategories.length !== 0 &&
    serverSetup.gameCategories[0].name.toLowerCase().replace(" ", "-");
  const [dashboardState, setDashboardState] = useState({
    categories: firstCategory || null,
    games: null,
  });
  // category
  const [selectedCategory, setSelectedCategory] = useState(null);

  // const [showSetLimitsDialog, setShowSetLimitsDialog] = useState(false);
  const [missingLimitsRedirect /* setMissingLimitsRedirect */] =
    useState(false);
  const [show, setShow] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  useEffect(() => {
    window.onpopstate = () => {
      setScrollOnBack(true);
    };
    scrollToTop();
  }, []);

  useEffect(() => {
    // console.log(titles)
    document.title = titles["index"];
  }, [titles]);

  let playerCountry =
    player && player.country !== undefined
      ? player.country
      : serverSetup.geoIP.isoCode.toLowerCase() !== ""
      ? serverSetup.geoIP.isoCode.toLowerCase()
      : config.defaultLang;

  let { lobby, orderedGameLobby } = useGetGameLobby(
    playerCountry,
    "",
    config.skin
  );

  useEffect(() => {
    lobby !== null &&
      orderedGameLobby !== null &&
      lobby[0] &&
      setDashboardState({
        categories: lobby[0]["categoryName"],
        games: config.skin !== "plc" ? orderedGameLobby.lobby : lobby,
      });
    if (
      config.skin === "plc" ||
      config.skin === "pub" ||
      config.skin === "cac"
    ) {
      setSelectedCategory("popular-games");
    } else {
      setSelectedCategory(null);
    }
  }, [lobby, orderedGameLobby]);

  useEffect(() => {
    if (config.skin === "rac" && session && bannedDepositPage) {
      if (!riskyCountry) {
        sessionStorage.setItem("user_banned_from_page", true);
      } else {
        sessionStorage.setItem("user_from_risky_country", true);
      }
      setSupportRedirect(true);
    }
  }, [session, bannedDepositPage, riskyCountry, setSweLimitDialog]);

  useEffect(() => {
    if (session && localStorage.getItem(SWE_LIMIT_DIALOG)) {
      setSweLimitDialog(true);
    }

    // if (
    //   config.skin === "rac" &&
    //   session &&
    //   hasWithdraw &&
    //   player.country !== "fi" &&
    //   player.country !== "se"
    // ) {
    //   setShowWithdrawAlertDialog(true);
    // }
  }, [
    session,
    // hasWithdraw,
    setSweLimitDialog,
    // setShowWithdrawAlertDialog,
    // player.country,
  ]);

  useEffect(() => {
    if (localStorage.getItem(PENDING_DEPOSIT)) {
      setShowBannedDialogWithMessage(true);
      localStorage.removeItem(PENDING_DEPOSIT);
    }
  }, []);

  useEffect(() => {
    if (scrollOnBack) {
      document.getElementById("scroll-to-category-onlogin")
        ? document.getElementById("scroll-to-category-onlogin").scrollIntoView()
        : scrollToTop();
    }
  }, [scrollOnBack]);

  if (session && player.country === "se") {
    checkSWEDepositLimit();
  }

  const onCategoryClick = async (category) => {
    //console.log(category);
    setSelectedCategory(category.replace(/ /g, "-"));
  };

  const setSearchResults = (e) => {
    //console.log(e.games.length);
    var gamesByCategory = [];

    gamesByCategory = e.games.reduce((r, a) => {
      r[a.gameType.toLowerCase().replace(" ", "-")] = [
        ...(r[a.gameType.toLowerCase().replace(" ", "-")] || []),
        a,
      ];
      return r;
    }, {});

    let gamesWithCategory = [];

    serverSetup.gameCategories.length !== 0 &&
      serverSetup.gameCategories.forEach((cat /*index*/) => {
        cat.isVisible &&
          gamesWithCategory.push({
            categoryName: cat.name.toLowerCase().replace(" ", "-"),
          });
      });

    gamesWithCategory.map(
      (cat, index) =>
        //console.log(cat.categoryName);
        (gamesWithCategory[index] = {
          ...gamesWithCategory[index],
          games: gamesByCategory[cat.categoryName] || [],
        })
    );
    setDashboardState({
      ...dashboardState,
      // dodaj na listu učitanih igara, u responseu je razlika
      games: gamesWithCategory.length !== 0 ? gamesWithCategory : null,
    });
    //console.log(gamesWithCategory.length !== 0 && gamesWithCategory);

    let firstCategory = gamesWithCategory.filter(
      (category) => category.games.length !== 0
    );
    let firstCategoryName =
      firstCategory.length !== 0 && firstCategory[0]["categoryName"];
    //console.log(firstCategoryName);

    setSelectedCategory(firstCategoryName);
  };

  const toggleShow = () => {
    setShow(!show);
  };

  if (supportRedirect) {
    return <Redirect to={pages["support"]}></Redirect>;
  }

  if (missingLimitsRedirect) {
    return <Redirect to={pages["my-limits"]}></Redirect>;
  }

  const { games } = dashboardState;
  //console.log('salje ' + JSON.stringify(games));
  return (
    <>
      {config.skin !== "rac" && (
        <>
          {/* Slider */}
          <Slides
            currentLanguage={serverSetup.currentLanguage}
            currentTheme={currentTheme}
            banners={serverSetup.banners}
            player={player}
            server={server}
            setIsOpen={setIsOpen}
            skin={config.skin}
            landingImagePath={config.landingImagePath}
            defaultLang={config.defaultLang}
            defaultCurrency={config.defaultCurrency}
          />
          {/* Skin Description Div */}
          <MainDescription pages={pages} skin={config.skin} />
          {/* Game menu */}
          <StyledFiltersWrapper>
            {currentTemplate === "fourth" || currentTemplate === "" ? (
              <StyledFilters>
                <Categories
                  onClick={onCategoryClick}
                  selected={selectedCategory}
                  onToggleShow={() => toggleShow()}
                  serverSetup={serverSetup}
                  gameLobby={games}
                  skin={config.skin}
                  pages={pages}
                />
                {!isMobileOnly && (
                  <StyledLoupeDiv onClick={onToggleSearchShow} />
                )}
              </StyledFilters>
            ) : (
              <ul>
                <Categories
                  serverSetup={serverSetup}
                  gameLobby={games}
                  skin={config.skin}
                  pages={pages}
                />
              </ul>
            )}
          </StyledFiltersWrapper>
          {/* Lobby */}
          {games === null ? (
            <LobbyWrapper gameLoader>
              <GamesLoader skin={config.skin} />
            </LobbyWrapper>
          ) : (
            <LobbyWrapper>
              <StyledTextCenter>
                <Lobby
                  gamesForCategory={true}
                  gameLobby={games}
                  selectedCategory={selectedCategory}
                  width={width}
                  skin={config.skin}
                  gameImagePath={config.gameImagePath}
                  config={config}
                  country={playerCountry}
                  themes={false}
                />
                <StyledLink
                  gotogames="true"
                  id="scroll-to-lobby"
                  btn="true"
                  spancol={"mt-4"}
                  to={pages["games"]}
                >
                  {t("label_go_to_games", "Go To Games")}
                </StyledLink>
              </StyledTextCenter>
            </LobbyWrapper>
          )}
          {/* Game provider list */}
          <StyledProviderLogo>
            <GameProvidersList
              setSearchResults={setSearchResults}
              skin={config.skin}
              currentTheme={currentTheme}
              serverSetup={serverSetup}
              vendorsImagePath={config.vendorsImagePath}
              setSpinner={setSpinner}
              setSelectedCategory={setSelectedCategory}
            />
          </StyledProviderLogo>
          {/* Play live section */}
          <StyledPlayLiveWrapper>
            <PlayLive pages={pages} skin={config.skin} />
          </StyledPlayLiveWrapper>
          {/* Payments List */}
          <StyledFader>
            <PaymentMethods
              currentTheme={currentTheme}
              pages={pages}
              serverSetup={serverSetup}
              currentLanguage={serverSetup.currentLanguage}
              skin={config.skin}
              paymentsImagePath={config.paymentsImagePath}
            />
          </StyledFader>
        </>
      )}
      {config.skin === "rac" && (
        <PnP
          server={server}
          player={player}
          pages={pages}
          currentTheme={currentTheme}
          depositList={depositList}
          setSpinner={setSpinner}
          setPxRegisterStart={setPxRegisterStart}
          setPxDepositStart={setPxDepositStart}
          skin={config.skin}
          paymentsImagePath={config.paymentsImagePath}
        />
      )}
      <BannedDialogWithMessage
        showModal={showBannedDialogWithMessage}
        handleProceed={() => setShowBannedDialogWithMessage(false)}
        message={t("label_pnp_pending_deposit")}
        skin={config.skin}
      />
    </>
  );
};

export default withRouter(Index);
